// ----------------------------------------------------------------------------
// Функция отправляет запрос на сервер для высылки пользователю ссылки (для подтверждения email) и
// выводит пользователю соответствующие сообщения.
// ----------------------------------------------------------------------------




import {removeElements} from "../auth-common/auth-misc-functions.js";
import {accountElements} from "../auth-common/auth-account-elements.js";


const ttAuthLinkSend = (e) => {
    e?.preventDefault();

    removeElements('.g-message');
    accountElements.accountHeader?.insertAdjacentHTML('afterend', '<div class="g-message">Обработка данных...</div>');

    fetch('/oauth/get_data.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: new URLSearchParams({ sendlink: 1 })
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('Сетевая ошибка сервера');
            }
            return response.json();
        })
        .then(data => {
            removeElements('.g-message');
            if (Number(data.RES) === 1) {
                accountElements.accountHeader?.insertAdjacentHTML('afterend', '<div class="g-message g-message--ok">' + data.MSG + '</div>');
            } else if (data.ERROR) {
                accountElements.accountHeader?.insertAdjacentHTML('afterend', '<div class="g-message g-message--error">' + data.ERROR + '</div>');
            } else {
                accountElements.accountHeader?.insertAdjacentHTML('afterend', '<div class="g-message g-message--error">Отправить ссылку не удалось. Попробуйте позже.</div>');
            }
        })
        .catch(error => {
            console.error('Произошла ошибка при отправке:', error);
        });

    return false;
}

export default ttAuthLinkSend;